// Shadow definitions extracted from the new design system

export const shadows = {
  // Base shadows
  sm: '0 2px 8px rgba(0, 0, 0, 0.1)',
  md: '0 4px 12px rgba(0, 0, 0, 0.08)',
  lg: '0 8px 24px rgba(0, 0, 0, 0.12)',
  xl: '0 12px 24px rgba(0, 0, 0, 0.1)',
  xxl: '0 20px 40px rgba(0, 0, 0, 0.1)',

  // Hover shadows
  hover: {
    sm: '0 4px 16px rgba(0, 0, 0, 0.15)',
    md: '0 8px 16px rgba(44, 90, 160, 0.3)',
    lg: '0 16px 32px rgba(0, 0, 0, 0.2)'
  },

  // Focus shadows
  focus: '0 0 0 3px rgba(44, 90, 160, 0.1)',

  // Colored shadows
  primary: '0 8px 16px rgba(44, 90, 160, 0.3)',
  success: '0 4px 12px rgba(46, 204, 113, 0.2)',
  error: '0 4px 12px rgba(231, 76, 60, 0.2)',
  warning: '0 4px 12px rgba(245, 166, 35, 0.2)',
  info: '0 4px 12px rgba(52, 152, 219, 0.2)',

  // Inner shadows
  inner: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',

  // Glass morphism shadows
  glass: '0 8px 32px rgba(31, 38, 135, 0.37)',
  glassSoft: '0 2px 8px rgba(0, 0, 0, 0.1)'
};
